import { message } from "antd";

import { BaseList, BaseDetail } from "App/Component/Bases";
import fields from "./fields";
import descriptor from "./descriptor";
import options from "./options";

const title = "Prefill Lines";
const urlData = "prefillLines";
const bulkName = "prefill_set.name";

class List extends BaseList {
  constructor(props) {
    super(props)

    this.title = title;
    this.urlData = urlData;
    this.bulkName = bulkName;
    this.propsList = {
      descriptor,
      exportImport: options.exportImportOptions,
      onExportClick: () => message.info('Do export from Prefillset page'),
      onImportClick: () => message.info('Do import from Prefillset page'),
    }
  }
}

class Detail extends BaseDetail {
  constructor(props) {
    super(props)

    this.title = title
    this.urlData = urlData
    this.bulkName = bulkName
    this.fields = fields
    this.propsDetail = {
      urlKeyHistory: 'api:admin:estimation:prefillline:detail-revision',
      keyLabel: 'line_template.label'
    }
  }
}

export default { List, Detail };